export enum CrudSaveResult {
  Success,
  Errors,
  Invalid,
}
